import React from 'react';
import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

export const IconMoney = (props: IconProps) => {
  const { size = 16, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 28 28"
      color={color ?? '#000'}
      {...otherProps}
    >
      <Path
        fill="currentColor"
        d="M13.1317 24.2083V21.7673C12.1162 21.5863 11.2415 21.1895 10.5079 20.577C9.77427 19.9645 9.23245 19.1079 8.88245 18.0072L10.5024 17.334C10.8164 18.2374 11.2639 18.9284 11.8449 19.4072C12.4261 19.8857 13.202 20.125 14.1727 20.125C15.0148 20.125 15.7579 19.9246 16.4019 19.5238C17.0457 19.1229 17.3676 18.4872 17.3676 17.6166C17.3676 16.8612 17.1257 16.258 16.6419 15.8071C16.158 15.3562 15.157 14.8855 13.6389 14.3949C12.049 13.8922 10.9447 13.3044 10.3262 12.6315C9.70767 11.9583 9.3984 11.1117 9.3984 10.0916C9.3984 8.91757 9.81053 7.99357 10.6348 7.31963C11.4588 6.64588 12.2912 6.27157 13.1317 6.19671V3.79163H14.8817V6.19671C15.7717 6.31493 16.5195 6.60436 17.1252 7.065C17.7311 7.52564 18.2023 8.12472 18.5387 8.86225L16.9415 9.59346C16.6856 9.03113 16.3288 8.5944 15.8711 8.28329C15.4135 7.97218 14.8115 7.81663 14.0651 7.81663C13.1872 7.81663 12.4815 8.03052 11.9482 8.45829C11.415 8.88607 11.1484 9.43052 11.1484 10.0916C11.1484 10.7706 11.4214 11.3136 11.9674 11.7206C12.5132 12.1274 13.528 12.5536 15.0118 12.9993C16.3908 13.4181 17.4199 14.0149 18.0991 14.7898C18.7781 15.5645 19.1176 16.4948 19.1176 17.5808C19.1176 18.8565 18.7074 19.8466 17.8871 20.5511C17.0667 21.2558 16.0649 21.6731 14.8817 21.8032V24.2083H13.1317Z"
      />
    </Svg>
  );
};
